<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}} ({{data.length}})
          </h3>
        </div>
        <div class="col text-right">
          <div class="row align-items-right">
            <SearchBox v-model="searchTerm" class="search-box"/>
            <base-button
              type="success"
              size="sm"
              icon="ni ni-fat-add"
              @click="$emit('addTeam')"
            >
              Add Team
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th>Name</th>
          <th v-if="type !== 'mixed'">Division</th>
          <th>Payment Type</th>
          <th>Toonie Pot</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            <div class="media align-items-center">
              <div class="avatar-group">
                <div
                  class="avatar rounded-circle"
                  v-for="(player, index) in row.players" :key="player ? player.id : index"
                  v-tooltip="player ? player.user.Name : ''"
                >
                  <img :src="getAvatarUrl(player ? player.user : null)" />
                </div>
              </div>
              <div class="name" @click="$emit('onEdit', row)">
                <span class="name mb-0 text-sm">{{row.Name}}</span>
              </div>
            </div>
          </th>
          <td class="type" v-if="type !== 'mixed'">
            <LeagueDivisionViewer :team="row" />
          </td>
          <td>
            <div class="payment-column">
              <div
                class="payment"
                v-for="(player, index) in row.players"
                :key="player ? player.id : index"
              >
                <i
                  class="fa fa-check text-success payment-icon"
                  v-if="player && player.paidInFull"
                />
                <i
                  class="fa fa-times text-deposit payment-icon"
                  v-else-if="player && player.paidDeposit"
                />
                <i
                  class="fa fa-money-bill text-warning payment-icon"
                  v-else
                />
                <span class="text-success" v-if="player && player.paidInFull">
                  {{player ? player.user.Name : ''}}
                </span>
                <span class="text-deposit" v-else-if="player && player.paidDeposit">
                  {{player ? player.user.Name : ''}}
                </span>
                <span class="text-warning" v-else>
                  {{player ? player.user.Name : ''}}
                </span>
              </div>
            </div>
          </td>
          <td>
            <div class="payment-column">
              <div
                class="payment"
                v-for="(player, index) in row.players"
                :key="player ? player.id : index"
              >
                <i
                  class="fa fa-coins text-success payment-icon"
                  v-if="player && player.tooniePot"
                />
                <i
                  class="fa fa-coins text-warning payment-icon"
                  v-else
                />
                <span class="text-success" v-if="player && player.tooniePot">
                  {{player ? player.user.Name : ''}}
                </span>
                <span class="text-warning" v-else>
                  {{player ? player.user.Name : ''}}
                </span>
              </div>
            </div>
          </td>
          <td class="text-right">
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              @click.prevent="$emit('onEdit', row)"
            >
              <i class="fa fa-edit"></i>
            </a>
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              @click.prevent="$emit('onRemove', row)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </td>

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination
        :total="filteredData.length"
        :perPage="perPage"
        v-model="currentPage"
      />
    </div>

  </div>
</template>
<script>
import Fuse from 'fuse.js';
import AvatarHelper from '@/helpers/Avatars';
import LeagueDivisionViewer from '@/components/LeagueDivisionViewer.vue';
import SearchBox from '@/components/SearchBox.vue';

export default {
  name: 'LeagueTeamsTable',
  components: {
    LeagueDivisionViewer,
    SearchBox,
  },
  props: {
    type: {
      type: String,
    },
    title: String,
    data: {
      type: Array,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      currentPage: 1,
      searchTerm: '',
    };
  },
  watch: {
    searchTerm() {
      if (this.searchTerm.length > 0) {
        this.currentPage = 1;
      }
    },
  },
  computed: {
    filteredData() {
      if (this.searchTerm.length > 0) {
        const options = {
          keys: ['Name'],
          threshold: 0.1,
        };

        const fuseSearch = new Fuse(this.data, options);
        const result = fuseSearch.search(this.searchTerm);
        return result
          .sort((a, b) => String(a.Name).localeCompare(b.Name));
      }
      return [...this.data].sort((a, b) => String(a.Name).localeCompare(b.Name));
    },
    tableData() {
      const startIndex = this.perPage * (this.currentPage - 1);
      const endIndex = this.perPage * this.currentPage;

      return this.filteredData.slice(startIndex, endIndex);
    },
  },
  methods: {
    getAvatarUrl(user) {
      return AvatarHelper.getAvatar(user);
    },
  },
};
</script>
<style lang="scss" scoped>
  .type{
    text-transform: capitalize;
  }
  .name{
    cursor: pointer;
  }
  .avatar{
    margin-right: 1rem;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .avatar-group{
    .avatar{
      margin-left: -2rem;

      &:first-child{
        margin-left: 0;
      }
    }
  }
  .payment-icon{
    width: 1.1rem;
    text-align: center;
  }
  .text-deposit {
    color: #f39c12;
  }
  .align-items-right {
    justify-content: flex-end;
    margin-right: 0rem;
  }
  .search-box {
    margin-right: 1rem;
  }
</style>
